import { Grid, useMediaQuery } from '@mui/material';
import { User } from '@thro-types/users';

import clsx from 'clsx';
import React from 'react';

import theme from 'styles/theme/theme';

import { DesktopDrawer } from './DesktopDrawer';
import { DesktopMenuBar } from './DesktopMenuBar';
import { DesktopOnly } from './DesktopOnly';
import { MobileMenuBar } from './MobileMenuBar';

interface Props extends React.PropsWithChildren<{}> {
  desktopOnly: boolean;
  mobilePadding: boolean;
  className?: string;
  heading?: string;
  renderHeading: () => JSX.Element;
  user?: User;
}

export const ResponiveLayoutWrapper = ({
  desktopOnly,
  mobilePadding,
  className,
  heading,
  renderHeading,
  children,
  user
}: Props) => {
  const isDesktop = useMediaQuery(theme('de').breakpoints.up('md'));

  return (
    <Grid container className={'content'}>
      <div
        className={clsx(
          'container',
          `container__body--mobile-padding${mobilePadding ? '--enabled' : '--disabled'}`,
          className
        )}
      >
        {isDesktop ? (
          <>
            <DesktopDrawer />
            <DesktopMenuBar
              heading={heading}
              renderHeading={renderHeading}
              className={className}
              user={user}
            />
          </>
        ) : (
          <MobileMenuBar heading={heading} renderHeading={renderHeading} />
        )}
        <div className={'container__body'}>
          {desktopOnly ? <>{isDesktop ? children : <DesktopOnly />}</> : children}
        </div>
      </div>
    </Grid>
  );
};
